import { render, staticRenderFns } from "./myClient.vue?vue&type=template&id=252ee273&scoped=true"
import script from "./myClient.vue?vue&type=script&lang=js"
export * from "./myClient.vue?vue&type=script&lang=js"
import style0 from "./myClient.vue?vue&type=style&index=0&id=252ee273&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ee273",
  null
  
)

export default component.exports